export enum LogLevel {
    DEBUG = 'debug',
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error',
    CRITICAL = 'critical',
}

/**
 * Returns a numeric value for a LogLevel which can be used for sorting and
 * filtering. The actual value of the number is arbitrary.
 */
export function logLevelToNumber(logLevel?: LogLevel): number {
    switch (logLevel) {
        case LogLevel.DEBUG:
            return 10;
        case LogLevel.INFO:
            return 20;
        case LogLevel.WARNING:
            return 30;
        case LogLevel.ERROR:
            return 40;
        case LogLevel.CRITICAL:
            return 50;
        default:
            return 0;
    }
}
